import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Home, ArrowLeftRight, ShoppingCart, DollarSign, History } from 'lucide-react';

const BottomNav = () => {
  const mode = useSelector(state => state.mode.mode);
  const location = useLocation();

  const menuItems = [
    {
      id: "wallets",
      label: "Home",
      icon: <Home size={20} />,
      path: "/dashboard",
      forPrivate: true,
    },
    {
      id: "swap",
      label: "Swap",
      icon: <ArrowLeftRight size={20} />,
      path: "/rango-exchange",
      forPrivate: false,
    },
    {
      id: "buy",
      label: "Buy",
      icon: <ShoppingCart size={20} />,
      path: "/on-ramping",
      forPrivate: false,
    },
    {
      id: "sell",
      label: "Sell",
      icon: <DollarSign size={20} />,
      path: "/off-ramping",
      forPrivate: false,
    },
    {
      id: "history",
      label: "History",
      icon: <History size={20} />,
      path: "/history",
      forPrivate: true,
    },
  ];

  return (
    <nav className="bottom-nav lg:hidden">
      {menuItems.map((item) => {
        if (mode === "private" && !item.forPrivate) {
          return null;
        }
        return (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => `bottom-nav-item ${isActive ? 'active' : ''}`}
          >
            <span className="bottom-nav-icon">{item.icon}</span>
            <span className="bottom-nav-label">{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default BottomNav;
